var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mail-interface",
      class: { "normal-mode": !_vm.isGridMode },
    },
    [
      _c("MailSidebar", {
        ref: "sidebar",
        attrs: {
          "selected-folder": _vm.selectedFolder,
          "selected-email-id": _vm.selectedEmailId,
          "user-emails": _vm.userEmails,
          "department-emails": _vm.departmentEmails,
          "email-addresses": _vm.allowedSenderMailAddresses,
          "is-grid-mode": _vm.isGridMode,
          "show-only-folders": _vm.showOnlyFolders,
        },
        on: {
          "folder-selected": _vm.selectFolder,
          "email-selected": _vm.selectMailAccount,
          "create-new-mail": _vm.createNewMail,
          "layout-mode-changed": _vm.toggleLayout,
          "change-mail-type": _vm.changedMailType,
        },
      }),
      _vm._v(" "),
      _vm.isGridMode
        ? [
            _c("MailList", {
              ref: "mailList",
              staticClass: "mail-list-grid",
              attrs: {
                "ref-visitor-id": _vm.refVisitorId,
                "selected-thread-id":
                  _vm.selectedThread && _vm.selectedThread._id,
                folder: _vm.selectedFolder,
                "mail-type": _vm.selectedEmailType,
                "selected-thread": _vm.selectedThread,
                "single-mode": _vm.mode === "folder-only",
              },
              on: { "thread-selected": _vm.selectThread },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mail-detail-container" },
              [
                _vm.showMailThread
                  ? _c("MailThread", {
                      attrs: { thread: _vm.selectedThread },
                      on: {
                        close: _vm.closeMailThread,
                        "thread-deleted": _vm.onThreadDeleted,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showMailCompose
                  ? _c("MailCompose", {
                      attrs: {
                        "mail-data": _vm.composeMailData,
                        "selected-email-id": _vm.selectedEmailId,
                        "enabled-select-sender": _vm.enabledSelectSender,
                      },
                      on: { close: _vm.closeComposeForm, sent: _vm.onMailSent },
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.showMailThread && !_vm.showMailCompose
                  ? _c("div", { staticClass: "empty-state" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", { staticClass: "empty-state-message" }, [
                        _vm._v(_vm._s(_vm.$t("mail.emptyStateMessage"))),
                      ]),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]
        : [
            !_vm.showMailThread && !_vm.showMailCompose
              ? _c("MailList", {
                  ref: "mailList",
                  staticClass: "mail-list-normal",
                  attrs: {
                    "ref-visitor-id": _vm.refVisitorId,
                    "selected-thread-id":
                      _vm.selectedThread && _vm.selectedThread._id,
                    folder: _vm.selectedFolder,
                    "mail-type": _vm.selectedEmailType,
                    "is-grid-mode": _vm.isGridMode,
                    "single-mode": _vm.mode === "folder-only",
                  },
                  on: { "thread-selected": _vm.selectThread },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showMailThread || _vm.showMailCompose
              ? _c(
                  "div",
                  { staticClass: "mail-detail-container" },
                  [
                    _vm.showMailThread
                      ? _c("MailThread", {
                          attrs: { thread: _vm.selectedThread },
                          on: {
                            close: _vm.closeMailThread,
                            "thread-deleted": _vm.onThreadDeleted,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showMailCompose
                      ? _c("MailCompose", {
                          attrs: {
                            "mail-data": _vm.composeMailData,
                            "selected-email-id": _vm.selectedEmailId,
                            "enabled-select-sender": _vm.enabledSelectSender,
                          },
                          on: { close: _vm.closeComposeForm },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-state-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("email")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }